import client from '@/store/api/client'

export default {
  getDepartments(callback) {
    client.get('/api/data/departments', callback)
  },

  newDepartement(newDepartement) {
    return client.ppost('/api/data/departments', {
      name: newDepartement.name,
      color: newDepartement.color,
      priority: Number(newDepartement.priority)
    })
  },

  editDepartement(editedDepartement) {
    const data = {
      name: editedDepartement.name,
      color: editedDepartement.color
    }
    if (editedDepartement.priority && editedDepartement.priority > 0) {
      data.priority = Number(editedDepartement.priority)
    }
    return client.pput(`/api/data/departments/${editedDepartement.id}`, data)
  },

  deleteDepartment(departementToDelete) {
    return client.pdel(`/api/data/departments/${departementToDelete.id}`)
  }
}
